import React, { useContext, useCallback, useState, useEffect, useMemo } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types';
import { BreakpointTrackerContext } from '@jutro/layout';
import { TranslatorContext } from '@jutro/locale';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, useDataRefresh, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import metadata from './RepairsOrAdditions.metadata.json5';


function RepairsOrAdditions(props) {
    const { item, saveData, cancelData, isInvalid, showErrors, onValidate} = props;
    const translator = useContext(TranslatorContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const [modalItem, updateModalItem] = useState(item);
    const { refreshData } = useDataRefresh();
    const [displayError, setDisplayError] = useState(false);
    const { onValidate: setComponentValidation, isComponentValid } = useValidation('RepairsOrAdditions');
    
    const errorHandling = useCallback(() => {
        if(!displayError) { setDisplayError(true) }
    }, [displayError] );
    
    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, 'RepairsOrAdditions');
        }
    }, [isComponentValid, onValidate]);
    
    useEffect(() => {
        isInvalid(isComponentValid, 'RepairsOrAdditions');
    }, [isInvalid, isComponentValid])
    
    const writeValue = useCallback(
        (value, path) => {
            if (path === 'repairDate' && !_.isUndefined(value) && !_.isUndefined(value.year) && value.year < 1988){
                _.set(modalItem, 'hasWPI8CertOfCompIssued_TWIA', undefined);
            }
            _.set(modalItem, path, value);
            updateModalItem(modalItem);
            refreshData();
        }, [modalItem, refreshData]
    );

    // DE15576
    const onSave = () => {
        if(!isComponentValid) {
            errorHandling();
            isInvalid(isComponentValid, 'RepairsOrAdditions');
        } else {
            saveData(modalItem);
        }
       
    }; 

    const onCancel = () => {
        setDisplayError(false);
        isInvalid(true, 'RepairsOrAdditions');
        cancelData();
    }

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        saveButtonId: {
            onClick: onSave
        },
        cancelButtonId: {
            onClick: onCancel
        },
        certificateOrStatement: {
            required: !_.isUndefined(modalItem.repairDate) && !_.isUndefined(modalItem.repairDate.year) && (modalItem.repairDate.year >= 1988 || (!_.isUndefined(modalItem.repairDate.year.value) && modalItem.repairDate.year.value >= 1988)) ? true : false,
            visible: !_.isUndefined(modalItem.repairDate) && !_.isUndefined(modalItem.repairDate.year) && (modalItem.repairDate.year >= 1988 || (!_.isUndefined(modalItem.repairDate.year.value) && modalItem.repairDate.year.value >= 1988))? true : false
        }
    }

    const resolvers = {
        resolveCallbackMap: {
        },
    }

    return (
        <ViewModelForm
            uiProps={metadata.pageContent} 
            overrideProps={overrideProps}
            model={modalItem}
            onValueChange={writeValue}
            showErrors={showErrors || displayError}
            onValidationChange={setComponentValidation}
            callbackMap={resolvers.resolveCallbackMap}
        />
    )
}

RepairsOrAdditions.propTypes = {
    item: PropTypes.shape({}).isRequired,
    saveData: PropTypes.func.isRequired
};


export default RepairsOrAdditions